import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MainCard from './MainCard';
import config from '../utils/config';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Call your backend API to send the reset link
        try {
                const response = await fetch(`${config.apiBaseUrl}/forgot-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });
            const data = await response.json();
            if (response.ok) {
                setMessage('Password reset link sent to your email.');
            } else {
                setMessage(data.error);
            }
        } catch (error) {
            setMessage('An error occurred. Please try again.');
        }
    };

    return (
        <div className="h-[450px] w-[450px] md:h-[750px] md:w-[750px] flex flex-col justify-center items-center">
            <MainCard>
                <h1 className="text-black text-[23px] md:text-[34px] w-full font-semibold font-['Inter'] mb-3">Forgot Password</h1>
                <form onSubmit={handleSubmit} className='w-[300px] md:w-[450px] h-auto justify-between gap-3 items-start flex flex-col'>
                    <div className="flex flex-col text-left justify-start items-start w-[350px] md:w-[750px]">
                        <div className="w-[350px] justify-between gap-2 items-start flex flex-col">
                            <span className='text-sm text-slate-600'>
                                Email
                            </span>
                        </div>
                        <input 
                            className={`py-1 px-[1px] md:px-3 h-[39px] rounded-md border w-[300px] md:w-[450px] border-slate-300`}
                            type="email" 
                            name="email" 
                            value={email} 
                            onChange={(e) => setEmail(e.target.value)} 
                            placeholder="Enter your email" 
                        />
                    </div>
                    
                    <div className="w-full mt-5 flex flex-col items-center">
                        <button 
                            className="w-[11rem] justify-center items-center text-white bg-shi-green border-shi-green text-sm md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border flex" 
                            type="submit">
                            Send Reset Link
                        </button>
                        <Link 
                            to="/login"
                            className="w-[300px] md:w-auto justify-center my-5 text-center text-shi-green bg-white border-white text-sm md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-200 items-start flex"
                            >Back to Login
                        </Link>
                    </div>
                    
                    {message && <p className='text-red-700 text-semibold'>{message}</p>}
                </form>
            </MainCard>
        </div>
    );
};

export default ForgotPassword;